import React from 'react'
import styles from "./Choose.module.css";
import { Logo, Lightbulb, overlayStyle, loaderStyle, SellerImage, BuyerImage, Buy_sellImage, UIImage, EasyImage, DatabaseImage, ToastContainer } from '../../common/common'
import { useNavigate } from 'react-router-dom';
import useGetUserData from '../../secureAPI/GetUserData';

const ChooseUserType = () => {
  const navigate = useNavigate();
  const navigateSellerPersonaldetails = (type) => { navigate(`/Business-details/${type}`); };
  const { users, isLoading } = useGetUserData();

  return (
    <div className="w-full flex flex-col lg:flex-row">
      {/* Left Sidebar - hidden on mobile, shown on lg screens */}
      <div className={`${styles.user} hidden lg:block lg:w-1/4 h-screen fixed`}>
        {/* <div className="h-[100px]">
          <div className="flex flex-row">
            <img className="mr-0" src={Logo} width={160} height={70} alt="Dashboard" />
          </div>
        </div> */}
        <div className="mt-8 lg:mt-32 mx-3 py-3">
          <p className="text-md font-bold text-[#02584e]">
            Thank you for signing up!
          </p>
          <h1 className="text-3xl lg:text-4xl leading-normal font-bold text-[#02584e] py-5">
            Choose the Best Platform to Grow Your Business
          </h1>
          <p className="text-md font-semibold text-[#02584e] mt-4">
           Tell us a bit about your current role and its scope. We'll also ask a few questions a ut your company so we can complete your registration and list your productt on the platform.
            <br /> <br />
            Lets get started.
          </p>
        </div>
        <div className="flex flex-row m-3 mt-8 lg:mt-40">
          <img
            className="top-0"
            src={Lightbulb}
            width={70}
            height={70}
            alt="Dashboard"
          />
          <p className="text-md font-bold text-[#02584e] ml-2">
            But why we need the information to personalize the onboarding
            process?
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full lg:ml-[25%] lg:w-9/12">
        <div className="text-center text-blue-700">
          <div className="w-full mx-auto p-2 flex flex-row text-center justify-center">
            <img src={Logo} width={160} height={70} alt="" />
          </div>
        </div>

        <div className="text-center text-[#02584e] my-3 px-4">
          <h1 className="text-2xl font-semibold text-[#02584e]">
            You want to become.
          </h1>
          <p className="text-[#02584e] font-semibold py-2">
            Awesome ! Choose your Role that are relevant to your business
          </p>
        </div>

        <div className="flex items-center justify-center container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-4xl">
            <div className="w-full">
              <div className="shadow-lg shadow-indigo-500/40 p-4 w-full rounded-xl relative min-h-[200px]">
                <h1 className="text-xl font-bold text-[#02584e]">
                  Become Seller
                </h1>
                <p className="text-[#02584e] font-semibold text-sm md:w-[80%] mt-3">
                  Accept orders from buyers. Submit your details to create an account and start selling.
                </p>
                <button
                  className="relative group px-8 md:px-12 mt-5 h-10 rounded-sm flex flex-row items-center bg-gradient-to-r from-[#085e56] to-[#3cbeb0] hover:bg-button-color"
                  onClick={() => navigateSellerPersonaldetails('Seller')}
                >
                  <span className="relative text-md text-center text-white font-semibold">
                    Select
                  </span>
                </button>
                <img
                  className="absolute top-[60px] right-[-10px] md:right-[-25px] border-none w-[100px] md:w-[150px]"
                  src={SellerImage}
                  alt="Dashboard"
                />
              </div>
            </div>

            <div className="w-full">
              <div className="shadow-lg shadow-indigo-500/40 p-4 w-full rounded-xl relative min-h-[200px]">
                <h1 className="text-xl font-bold text-[#02584e]">
                  Become Buyer
                </h1>
                <p className="text-[#02584e] font-semibold text-sm md:w-[80%] mt-3">
                 Place orders with sellers. Submit your details to creat an account and start buying.
                </p>
                <button
                  className="relative group px-8 md:px-12 mt-5 h-10 rounded-sm flex flex-row items-center bg-gradient-to-r from-[#085e56] to-[#3cbeb0] hover:bg-button-color"
                  onClick={() => navigateSellerPersonaldetails('buyer')}
                >
                  <span className="relative text-md text-center text-white font-semibold">
                    Select
                  </span>
                </button>
                <img
                  className="absolute top-[60px] right-[-10px] md:right-[-25px] border-none w-[100px] md:w-[150px]"
                  src={BuyerImage}
                  alt="Dashboard"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="my-8 px-4">
          <div>
            <h2 className="my-6 text-3xl md:text-5xl leading-10 text-center font-black text-[#02584e]">
              Why sellers choose Selzor?
            </h2>
          </div>
          <div className="flex items-center justify-center container mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full max-w-6xl px-4">
              <div className="bg-white text-center p-4 rounded-lg">
                <center>
                  <img
                    src={Buy_sellImage}
                    width={70}
                    height={70}
                    alt=""
                  />
                </center>
                <div className="bg-white text-center">
                  <h1 className="pt-3 pb-3 text-lg font-bold text-[#02584e]">
                    Sell to customers worldwide
                  </h1>
                  <p className="text-[#02584e] font-semibold text-sm">
                    Expand your reach and sell to customers across the globe.
                  </p>
                </div>
              </div>
              <div className="bg-white text-center p-4 rounded-lg">
                <center>
                  <img
                    src={UIImage}
                    width={70}
                    height={70}
                    alt=""
                  />
                </center>
                <div className="rounded-xl relative">
                  <h1 className="pt-3 pb-3 text-lg font-bold text-[#02584e]">
                    User Friendly B2B UI
                  </h1>
                  <p className="text-[#02584e] font-semibold text-sm">
                    Enjoy a simple and intuitive platform designed for businesses
                  </p>
                </div>
              </div>
              <div className="bg-white text-center p-4 rounded-lg">
                <center>
                  <img
                    src={EasyImage}
                    width={70}
                    height={70}
                    alt=""
                  />
                </center>
                <div className="rounded-xl relative">
                  <h1 className="pt-3 pb-3 text-lg font-bold text-[#02584e]">
                    Few Steps to start
                  </h1>
                  <p className="text-[#02584e] font-semibold text-sm">
                    Get started quickly with an easy onboarding process.
                  </p>
                </div>
              </div>
              <div className="bg-white text-center p-4 rounded-lg">
                <center>
                  <img
                    src={DatabaseImage}
                    width={70}
                    height={70}
                    alt=""
                  />
                </center>
                <div className="rounded-xl relative">
                  <h1 className="pt-3 pb-3 text-lg font-bold text-[#02584e]">
                    Cloud Data Security
                  </h1>
                  <p className="text-[#02584e] font-semibold text-sm">
                    "Your business data is protected with secure cloud technology.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>

      {isLoading && (
        <div style={overlayStyle}>
          <div style={loaderStyle}>Loading...</div>
        </div>
      )}
    </div>
  )
}

export default ChooseUserType